/**
 * Утилиты для определения типа браузера
 * Централизованное определение для избежания дублирования
 */

/**
 * Определяет, является ли браузер Safari (включая iOS и iPadOS)
 */
export const isSafari = (): boolean => {
  return (
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

/**
 * Определяет, является ли устройство iOS
 */
export const isIOS = (): boolean => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};
